import { Box, useColorModeValue } from "@chakra-ui/react";

export default function Drawer({ children, mode, isOpen, ...rest }) {
  const boxShadow = useColorModeValue(
    "0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14)",
    "none"
  );
  return (
    <Box
      top="38px"
      left="0px"
      position="fixed"
      height="calc(100vh - 38px)"
      width="256px"
      boxShadow={boxShadow}
      bg={mode === "video" ? "black70" : "surfaceElevated1"}
      transform={`translateX(${isOpen ? "0%" : "-130%"})`}
      {...rest}
      transition="all 300ms !important"
    >
      {children}
    </Box>
  );
}
